export default __webpack_public_path__ + "static/media/water_map.935e6070.png";